import { Pipe, PipeTransform } from '@angular/core';
import DOMPurify from 'dompurify'; // Use default import

@Pipe({
  name: 'sanitize',
  standalone: true
})
export class SanitizePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return DOMPurify.sanitize(value, {
      ALLOWED_TAGS: [], // No HTML tags allowed
      ALLOWED_ATTR: [], // No attributes allowed
      RETURN_TRUSTED_TYPE: false
    }).trim();
  }
}